<template>
    <v-btn 
        variant="tonal"
		class="floating-button" 
        :class="{
            'floating-button-left': justify === 'left',
            'floating-button-right': justify === 'right',
            'floating-button-center': justify === 'center'
        }"
        :color="color" 
        :elevation="elevation"
		@click="handleClick">

        <v-tooltip
            v-if="tooltipActive"
            activator="parent"
            :location="tooltipLocation">
            {{ tooltip }}
        </v-tooltip>

        <slot></slot>

	</v-btn>
</template>

<script>
    export default {
        name: 'FloatingButton',
        props: {
            justify: {
                type: String,
                default: 'right'
            },
            color: {
                type: String,
                default: 'color1'
            },
            elevation: {
                type: Number,
                default: 0
            },
            tooltip: {
                type: String,
                default: ''
            }
        },
        computed: {
            tooltipActive() {
                if (this.tooltip === null || this.tooltip === undefined || this.tooltip === '') {
                    return false
                }
                return true
            },
            tooltipLocation() {
                if (this.justify === 'left') return 'end'
                if (this.justify === 'right') return 'start'
                return 'center'
            }
        },
        emits: ['click'],
        methods: {
            handleClick() {
                this.$emit('click')
            }
        }
    }

</script>

<style scoped>
.floating-button {
    display: block;
    position: fixed;
    bottom: 5px;
    min-width: 54px;
    max-width: 54px;
    min-height: 54px;
    max-height: 54px;
    padding: 0px !important;
    z-index: 499;
	opacity: 0.8;
}

.floating-button-left {
    left: 5px;
}

.floating-button-right {
    right: 5px;
}

.floating-button-center {
    left: 50%;
    transform: translateX(-50%);
}

@media (max-width: 1600px) {
    .floating-button {
        min-width: 50px;
        max-width: 50px;
        min-height: 50px;
        max-height: 50px;
    }
}

@media (max-width: 1200px)
{
    .floating-button {
        min-height: 40px;
        max-height: 40px;
        max-width: 40px;
        min-width: 40px;
    }
}
</style>